import {
  b2AABB,
  b2Body,
  b2BodyDef,
  b2CircleShape,
  b2DistanceJointDef,
  b2FixtureDef,
  b2PolygonShape,
  b2PrismaticJointDef,
  b2RevoluteJointDef,
  b2Vec2,
  b2World,
} from "../box2d_flash/runtime/index.js";

b2Body.e_awakeFlag = 0;

export {
  b2AABB,
  b2Body,
  b2BodyDef,
  b2CircleShape,
  b2DistanceJointDef,
  b2FixtureDef,
  b2PolygonShape,
  b2PrismaticJointDef,
  b2RevoluteJointDef,
  b2Vec2,
  b2World,
};

export const PHYS_SCALE = 30;
export const FIXED_TIMESTEP = 1 / 30;
export const VELOCITY_ITERATIONS = 10;
export const POSITION_ITERATIONS = 10;
